import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { NxMessageModule } from '@aposin/ng-aquila/message';

import { Notification } from '#models/MicroController.model';

@Component({
  selector: 'kyc-notifications-group',
  imports: [CommonModule, NxMessageModule],
  templateUrl: './notifications-group.component.html',
})
export class NotificationsGroupComponent {
  readonly notifications = input.required<Notification[]>();
}
